import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhonePersonMessage = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6418 16.0104L12.632 19.9922C12.5353 20.5571 12.242 21.0696 11.8038 21.4391C11.3657 21.8085 10.8111 22.0111 10.238 22.0111H4.4284C3.78418 22.0111 3.16633 21.7553 2.71071 21.2998C2.2551 20.8444 1.99902 20.2266 1.99878 19.5824V5.77189C1.99901 5.12758 2.25507 4.50974 2.71066 4.05415C3.16625 3.59856 3.78409 3.34251 4.4284 3.34227H9.99971"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33276 19.0108C7.26683 19.0108 7.20237 19.0303 7.14755 19.0669C7.09273 19.1036 7.05 19.1556 7.02477 19.2166C6.99953 19.2775 6.99293 19.3445 7.0058 19.4092C7.01866 19.4738 7.05041 19.5332 7.09703 19.5799C7.14366 19.6265 7.20306 19.6582 7.26772 19.6711C7.33239 19.684 7.39942 19.6774 7.46034 19.6521C7.52125 19.6269 7.57332 19.5842 7.60995 19.5293C7.64658 19.4745 7.66613 19.4101 7.66613 19.3441C7.66613 19.2557 7.63101 19.1709 7.56849 19.1084C7.50597 19.0459 7.42118 19.0108 7.33276 19.0108Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66577 14.0102C4.66577 13.3029 4.94676 12.6245 5.44691 12.1243C5.94707 11.6242 6.62542 11.3432 7.33275 11.3432V11.3432C8.04007 11.3432 8.71843 11.6242 9.21859 12.1243C9.71874 12.6245 9.99973 13.3029 9.99973 14.0102V14.0102"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33252 9.34298C5.33252 9.87347 5.54326 10.3822 5.91837 10.7574C6.29349 11.1325 6.80226 11.3432 7.33275 11.3432C7.86325 11.3432 8.37201 11.1325 8.74713 10.7574C9.12225 10.3822 9.33298 9.87347 9.33298 9.34298C9.33298 8.81248 9.12225 8.30371 8.74713 7.9286C8.37201 7.55348 7.86325 7.34274 7.33275 7.34274C6.80226 7.34274 6.29349 7.55348 5.91837 7.9286C5.54326 8.30371 5.33252 8.81248 5.33252 9.34298V9.34298Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3339 2.00883C16.4372 2.00471 15.5585 2.26014 14.8039 2.74431C14.0492 3.22848 13.4507 3.92069 13.0807 4.73743C12.7107 5.55417 12.5849 6.46053 12.7185 7.34716C12.8522 8.23379 13.2396 9.06281 13.8339 9.73417L13.2498 13.0937L16.2928 11.2179C16.933 11.3649 17.5971 11.3749 18.2414 11.2475C18.8858 11.12 19.496 10.8578 20.032 10.4782C20.568 10.0985 21.0177 9.60989 21.3518 9.04433C21.6859 8.47877 21.8967 7.84903 21.9705 7.19633C22.0442 6.54364 21.9793 5.88273 21.7799 5.25687C21.5806 4.63101 21.2512 4.05433 20.8135 3.56459C20.3758 3.07485 19.8395 2.6831 19.2399 2.415C18.6402 2.14689 17.9907 2.00848 17.3339 2.00883V2.00883Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhonePersonMessage.displayName = 'SvgPhonePersonMessage';
export default SvgPhonePersonMessage;
